import './tags.scss'
export type Tag = {
  _id: string
  name: string
  colour: string
  isActive: boolean
  createdAt?: string
  createdBy?: { adminId?: string; adminName?: string }
  deactivatedBy?: { adminId?: string; adminName?: string }
  deactivatedAt?: string | null
}

type Props = {
  /** Tag ids as stored on the shipment. */
  tagIds?: string[]
  /** id -> tag, from the global context. */
  tagsById: Record<string, Tag>
  /** Rendered when the shipment has no tags. Omit to render nothing. */
  empty?: string
}

/**
 * Read-only tag chips for list rows and detail headers.
 *
 * Ids that resolve to nothing are skipped rather than rendered as raw
 * ObjectIds — that happens only if the tag list has not loaded yet.
 */
function TagChips({ tagIds, tagsById, empty }: Props) {
  const tags = (tagIds || []).map((id) => tagsById?.[id]).filter(Boolean)

  if (!tags.length) {
    return empty ? <span className='tag-chips-empty'>{empty}</span> : null
  }

  return (
    <span className='tag-chips'>
      {tags.map((tag) => (
        <span
          key={tag._id}
          className='tag-chip'
          title={tag.isActive ? tag.name : `${tag.name} (deleted tag)`}
          style={{
            background: `${tag.colour}1A`,
            color: tag.colour,
            border: `1px solid ${tag.colour}55`,
            // A deleted tag stays visible on shipments already carrying it,
            // dimmed so it reads as historical rather than current.
            opacity: tag.isActive ? 1 : 0.55,
          }}
        >
          {tag.name}
        </span>
      ))}
    </span>
  )
}

export default TagChips
